import { IHttpResponse, IHttpService, IPromise, IQService } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { ISelectedItem } from '../../../shared/components/gmc-select/interfaces';
import { cloneDeep } from 'lodash-es';
import { IGmcSelectOption } from '../../../ui/gmc-select/gmc-select-option.interface';
import { ApiService } from '../api-service/api.service';

export class CountryService {
  static $inject = ['$http', '$q', 'GmcApi', 'ApiService'];
  continents: string[] = [
    'Africa',
    'Antarctica',
    'Asia',
    'Europe',
    'North America',
    'Oceania',
    'South America'
  ];
  private cities: { [key: string]: string[] } = {};
  private countries: any[];
  private nationalities: string[];

  constructor(
    private $http: IHttpService,
    private $q: IQService,
    private gmcApi: GmcApi,
    private apiService: ApiService
  ) {
    this.initData();
  }

  getCountries(): IPromise<string[]> {
    if (!this.countries) {
      return this.$http
        .get<string[]>(this.gmcApi.helpers.getCountries)
        .then((res) => {
          this.countries = res.data;
          return cloneDeep(this.countries);
        });
    }
    return this.$q.resolve(cloneDeep(this.countries));
  }

  getAllNationalities(): IPromise<string[]> {
    if (!this.nationalities) {
      return this.$http
        .get<string[]>(this.gmcApi.helpers.getNationalities)
        .then((res: IHttpResponse<any>) => {
          this.nationalities = res.data.result;
          console.log(res);
          return cloneDeep(this.nationalities);
        });
    }
    return this.$q.resolve(cloneDeep(this.nationalities));
  }

  getCountriesOptions(): IPromise<Array<IGmcSelectOption<string>>> {
    return this.getCountries().then((countries) => {
      return countries.map((item) => ({ label: item, id: item, value: item }));
    });
  }

  getUserTopCountries(): IPromise<any> {
    return this.apiService
      .get<any>('/pages/all/getUserTopCountries')
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getContinents(): IPromise<ISelectedItem[]> {
    return null;
  }

  getAirports(airport: string) {
    return this.apiService.get(`/pages/all/findAirport?airport=${airport}`).then((res) => {
      return res;
    })
  }

  getCitiesByCountry(
    country: string,
    newParam = { country }
  ): IPromise<string[]> {
    if (this.cities[country]) {
      return this.$q.resolve(this.cities[country]);
    }
    const params = newParam;
    return this.$http
      .get<string[]>(this.gmcApi.helpers.getAllCities, { params, cache: true })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.cities[country] = res.data;
          return this.cities[country];
        }
        throw res;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  }

  private initData() {}
}



// WEBPACK FOOTER //
// ./app/core/services/country/country-service.ts